import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueLocationsController', IssueLocationsController);

    /** @ngInject */
    function IssueLocationsController(
        $scope,
        $http,
        $state,
        CompanyFactory,
        CompaniesFactory,
        FormVerificationService,
        ngDialog,
        toastr,
    ) {
        var vm = this;

        init();

        function init() {
            vm.getAssetChildren = function (assetId) {
                return $http.get(`/api/v1/assets/${assetId}/`);
            };

            vm.individualClientSelected = individualClientSelected;
            vm.displayAlternativeIdInput = displayAlternativeIdInput;

            vm.clientSelected = clientSelected;
            vm.imClientSelected = imClientSelected;
            vm.iwClientSelected = iwClientSelected;
            vm.addAsset = addAsset;
            vm.removeAsset = removeAsset;
            vm.clientHasAssets = clientHasAssets;
            vm.save = save;

            vm.issue = $scope.ngDialogData.issue;
            vm.company = $scope.ngDialogData.company;

            // store client selected from dropdown list or set by using location search input
            vm.client = null;

            // store list of assets owned by the selected client
            vm.assets = [];

            // store assets selected from dropdown list
            vm.selectedAssets = [[null, null, null]];

            // store asset found by using search input
            vm.foundAsset = null;

            CompaniesFactory.readOneHa(vm.issue.customer.party_uuid)
                .then(function (response) {
                    vm.client = response.data;
                })
                .then(function () {
                    return CompaniesFactory.getLocations({
                        page_size: 1000,
                        customer: vm.client.party_uuid,
                    }).then(function (response) {
                        vm.assets = response.data.results;
                    });
                })
                .then(function () {
                    vm.selectedAssets = [];
                    vm.issue.locations.forEach(function (loc) {
                        if (loc.asset) {
                            vm.getAssetChildren(loc.asset.asset_id).then(
                                (response) => {
                                    loc.asset.children = response.data.children;
                                    if (loc.sub_asset) {
                                        loc.asset.children.forEach(
                                            function (subloc) {
                                                if (
                                                    subloc.asset_id ===
                                                    loc.sub_asset.asset_id
                                                ) {
                                                    loc.sub_asset.children =
                                                        subloc.children;
                                                }
                                            },
                                        );
                                    }
                                    vm.selectedAssets.push([
                                        loc.asset,
                                        loc.sub_asset,
                                        loc.sub_sub_asset,
                                    ]);
                                },
                            );
                        } else {
                            vm.selectedAssets.push([loc.address, null, null]);
                        }
                    });

                    CompanyFactory.readCompany().then(function (response) {
                        vm.company = response.data.organization.party_uuid;
                        CompaniesFactory.readCompanies(vm.company).then(
                            function (companyResponse) {
                                vm.companySettings = companyResponse.data;
                            },
                        );
                    });
                });
        }

        function clientSelected(): boolean {
            return vm.client;
        }

        function imClientSelected(): boolean {
            return vm.client?.som;
        }

        function iwClientSelected(): boolean {
            return vm.client && !vm.client.som;
        }

        function individualClientSelected(): boolean {
            return vm.client?.business_type.value === 'KI';
        }

        function addAsset() {
            vm.selectedAssets.push([null, null, null]);
        }

        function removeAsset(index) {
            vm.selectedAssets.splice(index, 1);
        }

        function clientHasAssets(): boolean {
            return vm.assets?.length;
        }

        function displayAlternativeIdInput(): boolean {
            return vm.companySettings?.client_number_assignable;
        }

        function save() {
            var issueData = {
                locations: fillLocation(),
            };

            CompaniesFactory.editIssue(vm.company, vm.issue.id, issueData).then(
                function () {
                    toastr.success('Zapisano.');
                    ngDialog.close();
                    $state.reload('company_employee.issue_list');
                },
                function (error) {
                    FormVerificationService.error(error.data, vm.form);
                },
            );
        }

        function fillLocation() {
            return vm.selectedAssets.map(function (asset) {
                if (typeof asset[0] === 'string') {
                    return { short_address: asset[0] };
                }
                return {
                    asset: asset[0] && asset[0].asset_id,
                    sub_asset: (asset[1] && asset[1].asset_id) || null,
                    sub_sub_asset: (asset[2] && asset[2].asset_id) || null,
                    sub_premise:
                        (asset[1] && asset[1].sub_premise) ||
                        (asset[2] && asset[2].sub_premise) ||
                        null,
                };
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/issue-locations-dialog/issue-locations.controller.ts